import { IArticleData } from "../../interface/article";
import { Description, Title, Cardbox } from "./Card.Styles";
const Card = (props: IArticleData) => (
  <Cardbox to={props.slug}>
    <Title>{props.title}</Title>
    <Description>{props.description}</Description>
  </Cardbox>
);
export default Card;
